export default function Testimonials() {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      text: 'The therapy sessions here have been life-changing. The peaceful coastal environment combined with professional care helped me overcome anxiety I had struggled with for years.',
      avatar: 'https://public.readdy.ai/ai/img_res/9254d388b2b5031ef1dc759b6ff04bad.jpg',
      type: 'standard'
    },
    {
      name: 'Michael Chen',
      text: 'After trying several therapists, I finally found the right fit here. The approach is compassionate, evidence-based, and truly effective. I feel heard and supported every session.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20asian%20man%20in%20his%20forties%20with%20genuine%20smile%2C%20natural%20lighting%2C%20simple%20clean%20background%2C%20professional%20photography%2C%20trustworthy%20and%20warm%20expression&width=200&height=200&seq=testimonial-avatar-002&orientation=squarish',
      type: 'standard'
    },
    {
      name: 'Emily Rodriguez',
      image: 'https://readdy.ai/api/search-image?query=peaceful%20woman%20walking%20alone%20on%20serene%20beach%20at%20sunset%20with%20gentle%20waves%2C%20therapeutic%20and%20contemplative%20mood%2C%20soft%20golden%20hour%20lighting%2C%20calm%20ocean%20in%20background%2C%20professional%20photography%2C%20healing%20atmosphere&width=600&height=400&seq=testimonial-beach-001&orientation=landscape',
      quote: 'Finding peace within myself',
      type: 'image'
    },
    {
      name: 'David & Lisa Thompson',
      text: 'Couples therapy saved our marriage. We learned to communicate better, understand each other deeply, and rebuild the connection we thought we had lost. We are forever grateful for the guidance and support we received here.',
      image: 'https://readdy.ai/api/search-image?query=couple%20sitting%20together%20in%20peaceful%20coastal%20therapy%20session%20with%20ocean%20view%2C%20warm%20natural%20lighting%2C%20comfortable%20therapeutic%20setting%2C%20professional%20environment%2C%20hopeful%20and%20healing%20atmosphere%2C%20simple%20clean%20background&width=800&height=400&seq=testimonial-couples-001&orientation=landscape',
      type: 'wide'
    },
    {
      name: 'Jennifer Park',
      text: 'Highly recommend!',
      type: 'mini'
    },
    {
      name: 'Robert Williams',
      text: 'Best decision I ever made.',
      type: 'mini'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-[#F8FAFB]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-3 h-3 bg-[#A8DADC] rotate-45"></div>
            <span className="text-[#2C5F7C] text-sm font-semibold tracking-wider uppercase" style={{ fontFamily: 'Inter, sans-serif' }}>
              Client Experiences
            </span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            Stories of Healing
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-6 mb-6">
          {testimonials.slice(0, 3).map((testimonial, index) => (
            <div key={index}>
              {testimonial.type === 'standard' && (
                <div className="bg-white rounded-3xl p-8 h-[320px] shadow-sm hover:shadow-md transition-shadow">
                  <i className="ri-double-quotes-l text-4xl text-[#2C5F7C] mb-4"></i>
                  <p className="text-gray-700 text-base leading-relaxed mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {testimonial.text}
                  </p>
                  <div className="flex items-center gap-3 mt-auto">
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-semibold text-gray-900 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                        {testimonial.name}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {testimonial.type === 'image' && (
                <div className="relative rounded-3xl overflow-hidden h-[320px] shadow-sm hover:shadow-md transition-shadow">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                  <div className="absolute bottom-6 left-6 text-white">
                    <p className="text-xl font-semibold mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>
                      {testimonial.quote}
                    </p>
                    <p className="text-sm opacity-90" style={{ fontFamily: 'Inter, sans-serif' }}>
                      - {testimonial.name}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-3 gap-6">
          <div className="col-span-2">
            {testimonials[3].type === 'wide' && (
              <div className="relative rounded-3xl overflow-hidden h-[280px] shadow-sm hover:shadow-md transition-shadow">
                <img
                  src={testimonials[3].image}
                  alt={testimonials[3].name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-[#2C5F7C]/90 via-[#2C5F7C]/70 to-transparent"></div>
                <div className="absolute inset-0 p-8 flex flex-col justify-center">
                  <i className="ri-double-quotes-l text-3xl text-white/80 mb-3"></i>
                  <p className="text-white text-lg leading-relaxed mb-4 max-w-2xl" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {testimonials[3].text}
                  </p>
                  <p className="text-white font-semibold text-base" style={{ fontFamily: 'Inter, sans-serif' }}>
                    - {testimonials[3].name}
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-col gap-6">
            {testimonials.slice(4, 6).map((testimonial, index) => (
              <div key={index} className="bg-white rounded-3xl p-6 h-[130px] shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between">
                <i className="ri-double-quotes-l text-2xl text-[#2C5F7C]"></i>
                <div>
                  <p className="text-gray-700 text-sm mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {testimonial.text}
                  </p>
                  <p className="font-semibold text-gray-900 text-xs" style={{ fontFamily: 'Inter, sans-serif' }}>
                    - {testimonial.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
